// ----------------------------------------------------------------------

import { report } from 'process';

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/dashboard',
  REPORTS: '/reports',
  USERS: '/users',
  MANAGEMENT: '/management',
  XERO: '/xero',
  COA: '/coa',
  ERROR: '/RedirectError',
  COMPASS: '/compass',
  PMS: '/pms',
};

// ----------------------------------------------------------------------

export const paths = {
  faqs: '/faqs',
  // AUTH
  auth: {
    amplify: {
      signIn: `${ROOTS.AUTH}/amplify/sign-in`,
      verify: `${ROOTS.AUTH}/amplify/verify`,
      signUp: `${ROOTS.AUTH}/amplify/sign-up`,
      updatePassword: `${ROOTS.AUTH}/amplify/update-password`,
      resetPassword: `${ROOTS.AUTH}/amplify/reset-password`,
    },
    jwt: {
      signIn: `${ROOTS.AUTH}/jwt/sign-in`,
      signUp: `${ROOTS.AUTH}/jwt/sign-up`,
    },
    firebase: {
      signIn: `${ROOTS.AUTH}/firebase/sign-in`,
      verify: `${ROOTS.AUTH}/firebase/verify`,
      signUp: `${ROOTS.AUTH}/firebase/sign-up`,
      resetPassword: `${ROOTS.AUTH}/firebase/reset-password`,
    },
    auth0: {
      signIn: `${ROOTS.AUTH}/auth0/sign-in`,
    },
    supabase: {
      signIn: `${ROOTS.AUTH}/supabase/sign-in`,
      verify: `${ROOTS.AUTH}/supabase/verify`,
      signUp: `${ROOTS.AUTH}/supabase/sign-up`,
      updatePassword: `${ROOTS.AUTH}/supabase/update-password`,
      resetPassword: `${ROOTS.AUTH}/supabase/reset-password`,
    },
    changePassword: `${ROOTS.AUTH}/change-password`,
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
  },
  error: {
    root: ROOTS.ERROR,
  },
  // REPORTS
  reports: {
    root: `${ROOTS.REPORTS}`,
    viewer: `${ROOTS.REPORTS}/viewer`,
  },
  xero: {
    root: `${ROOTS.XERO}`,
    integrations: `${ROOTS.XERO}/integrations`,
    integrationsCreate: `${ROOTS.XERO}/integrations/create`,
    coa: `${ROOTS.XERO}/coa/A917236`,
  },
  compass: {
    root: `${ROOTS.COMPASS}`,
    list: `${ROOTS.COMPASS}/list`,
    edit: (id: string) => `${ROOTS.COMPASS}/${id}/edit`,
    create: `${ROOTS.COMPASS}/create`,
  },
  coa: {
    root: `${ROOTS.COA}`,
    list: `${ROOTS.COA}/list`,
    edit: (id: string) => `${ROOTS.COA}/${id}/edit`,
  },
  pms:
  {
    root: `${ROOTS.PMS}`,
    soe: {
      root: `${ROOTS.PMS}/soe-excact`,
      list: `${ROOTS.PMS}/soe-excact/list`,
      create: `${ROOTS.PMS}/soe-excact/create`
    }
  },
  // USERS
  users: {
    root: `${ROOTS.USERS}`,
    create: `${ROOTS.USERS}/create`,
    edit: (id: string) => `${ROOTS.USERS}/${id}/edit`,
  },
  // MANAGEMENT
  management: {
    root: `${ROOTS.MANAGEMENT}`,
    tenants: {
      root: `${ROOTS.MANAGEMENT}/tenants`,
      create: `${ROOTS.MANAGEMENT}/tenants/create`,
      edit: (id: string) => `${ROOTS.MANAGEMENT}/tenants/${id}/edit`,
      rls: (id: string) => `${ROOTS.MANAGEMENT}/tenants/${id}/rls`,
      users: {
        root: (tenantId: string) => `${ROOTS.MANAGEMENT}/tenants/${tenantId}/users`,
        create: (tenantId: string) => `${ROOTS.MANAGEMENT}/tenants/${tenantId}/users/create`,
        edit: (tenantId: string, id: string) =>
          `${ROOTS.MANAGEMENT}/tenants/${tenantId}/users/${id}/edit`,
      },
    },
    users: {
      root: `${ROOTS.MANAGEMENT}/users`,
      create: `${ROOTS.MANAGEMENT}/users/create`,
      edit: (id: string) => `${ROOTS.MANAGEMENT}/users/${id}/edit`,
    },
  },
};
